/**
 * Utility to manage performance calculations and heatmap colors
 */

export const calculatePerformance = (actual, target) => {
  if (!target || target <= 0) return 0;
  return (actual / target) * 100;
};

export const getHeatmapClass = (percentage) => {
  if (percentage <= 0) return 'text-gray-400 bg-gray-100';
  if (percentage < 50) return 'text-red-700 bg-red-100';     // Critical: Below 50%
  if (percentage < 80) return 'text-yellow-700 bg-yellow-100'; // Warning: 50% - 80%
  return 'text-green-700 bg-green-100';                      // Good: Above 80%
};

export const getBarColor = (percentage) => {
  if (percentage <= 0) return 'bg-gray-300';
  if (percentage < 50) return 'bg-red-500';
  if (percentage < 80) return 'bg-yellow-500';
  return 'bg-green-500';
};

export const getBarColorOnly = (percentage) => {
  if (percentage <= 0) return 'gray';
  if (percentage < 50) return 'red';
  if (percentage < 80) return 'yellow';
  return 'green';
};